import React from "react"
import FieldReaction_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldVoting_View from "./render/view"
import FieldConfig from "../../proto/field-config";
import CustomFieldsV1 from "../../../gd/const/fields/custom-fields-v1";
import {GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import Reactions from "../../../model2/reaction/reactions";
import Votes from "../../../model2/voting/votes";
import {FieldType} from "../../field-type";
import {SessionCustomField} from "../../../gd-model/custom-field/gd-custom-field";
import FieldVoting_ManagementPreview from "./render/management/management-preview";
import FieldVoting_ManagementFormCFV1 from "./render/management/management-form-cfv1";
import FieldVoting_InlineValueEmpty from "./components/inline-edit/value-empty";
import FieldProto from "../../proto/field-proto";
import FieldVoting_Editable from "./render/editable/editable";
import {ALL_REACTIONS} from "../../../model2/reaction/const";
import {SortDirection} from "../../../data-structures/sort";
import ItemModel from "../../../model2/item/item-model";
import FieldVotes_Popover from "./components/popover/popover-menu";
import FieldVoting_ViewProperty from "./render/property"

// export default class FieldReaction extends FieldDropdown {
export default class FieldVoting extends FieldProto {

    FIELD_DEFAULT_WIDTH: number = 100;

    static iconOptions: Option[]        = [
        { label: ALL_REACTIONS[20]  , value: 20 },
        { label: ALL_REACTIONS[200] , value: 200 },
        { label: ALL_REACTIONS[205] , value: 205 },
        { label: ALL_REACTIONS[233] , value: 233 },
    ]

    constructor(config:FieldConfig) {
        super(config);

        this.typeInteger        = CustomFieldsV1.type.VOTING
        this.typeLabel          = "Voting";
        this.filterType         = null; //'color';
        this.typeGroup          = GROUP_MISC
        this.typeDescription    = "Voting"
        this.icon               = 'i5-thumb-up';

        this.label              = config.label || '' // 'Reaction' // here Reaction word is used as default value for a label when create a new field

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.isSearchable           = true
        this.isColorCodingAvailable = false

        this.components.PopoverMenu                 = FieldVotes_Popover
        this.components.InlineValueNotEmpty         = FieldReaction_InlineValueNotEmpty
        this.components.InlineValueEmpty            = FieldVoting_InlineValueEmpty

        this.renderComponents.view                  = FieldVoting_View
        this.renderComponents.viewSmall             = FieldVoting_View
        this.renderComponents.viewProperty          = FieldVoting_ViewProperty

        this.renderComponents.inlineEditable        = FieldVoting_Editable
        this.renderComponents.editable              = FieldVoting_Editable

        // this.renderComponents.tableCell             = FieldReaction_TableCell // Not editable because editable is multiline not single line
        // this.renderComponents.viewProperty          = FieldTReaction_ViewProperty
        //
        this.renderComponents.managementPreview     = FieldVoting_ManagementPreview
        this.renderComponents.managementFormCFV1    = FieldVoting_ManagementFormCFV1

    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldVoting({
            fieldId         : customFieldV1.id,
            type            : FieldType.VOTING,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }


    // getViewValue(model:any) {
    //     const value = _.get(model, this.fieldId, null)
    //     const votes : Votes = Votes.initFromJson(value)
    //     return votes.total
    // }



    // Vote Icon

    get voteIcon():number {
        return this.fieldParams.voteIcon || 20
    }

    public renderVoteIcon():any {
        return <div className="ui5-emoji">{ALL_REACTIONS[this.voteIcon]}</div>
    }

    // START Value helpers

    toggleValue(model:any, optionValue:any) {
        if (this.hasValue(model, optionValue)) {
            return this.removeValue(model, optionValue)
        } else {
            return this.addValue(model, optionValue)
        }
    }

    addValue(model:any, reactionType:any) {
        const currentValue : Reactions = Reactions.initFromJson(this.getViewValue(model))
        currentValue.addMyReaction(reactionType)
        return currentValue.toJSON()
    }

    removeValue(model:any, optionValue:any) {
        const currentValue : Reactions = Reactions.initFromJson(this.getViewValue(model))
        currentValue.removeMyReaction(optionValue)
        return currentValue.toJSON()
    }

    isEmpty(model:any) {
        const currentValue : Votes = Votes.initFromJson(this.getViewValue(model))
        return currentValue.isEmpty
    }

    // END Value helpers


    // normalize value for sorting
    sortValue(value:any, model?:any) {

        console.error("NOT IMPLEMENTED #voting-field-error-222-103")
    }

    // sort function
    listItemSortFunctions(sort: SortDirection):any {

        return {
            functions: [
                (i:ItemModel) => {
                    const value = this.getViewValue(i.item) || null
                    if (!value) return 0

                    const votes : Votes = Votes.initFromJson(value)
                    return votes.total || 0
                }
            ],
            directions: [sort]
        }

    }


    toJson() {
        let result = super.toJson();

        // we DO NOT want to export options
        delete result.options

        return result;
    }

}
